import { useEffect } from 'react'

export const useInitialEffect = (cb: Function) => {
    useEffect(() => {
        cb()
    }, []) // eslint-disable-line
}
